import React from "react";
import { Reveal, Prose, PETROL } from "@/components/home/homeUi";

const BODY = [
  "Mi minden válhat lehetségessé, ha nem csupán felismered, mi működtet téged, hanem lehetőséget teremtesz arra is, hogy mindez átrendeződjön benned? A tematikus kiscsoportos alkalmak egy egymásra épülő, folyamatosan kibontakozó sorozatot alkotnak. Az alapoktól indulunk, majd lépésről lépésre egyre mélyebb rétegekhez, összefüggésekhez és működésekhez érkezünk.",
  "A Forrás-Kód® kísérés során nem csupán a felismerésekre helyezzük a hangsúlyt, hanem az egyéni kiigazításokra, a felszabadulásra és az új működési lehetőségek megnyitására is. A közös témák mentén minden résztvevő a saját élethelyzetével és egyéni folyamataival kapcsolódhat. Így a csoportdinamika és a személyes kísérés egyszerre kap teret, miközben a közösen feltáruló összefüggések újabb és újabb lehetőségeket nyithatnak meg. Az alkalmak egymásra épülnek, ugyanakkor külön-külön is látogathatók. Bármelyik témánál bekapcsolódhatsz, amelyik éppen megszólít, és ott folytathatod, ahol a saját utadon tartasz.",
];

const QUOTE = "font-serif-display italic text-graphite text-[21px] sm:text-[24px] md:text-[27px] leading-[1.5] max-w-3xl mx-auto";

export default function GroupProgramsIntro() {
  return (
    <section
      data-testid="group-programs-intro"
      className="relative px-6 md:px-10 pt-6 md:pt-10 pb-10 md:pb-14"
      style={{
        background:
          "radial-gradient(ellipse 60% 45% at 50% 12%, rgba(214,186,128,0.20), rgba(249,248,246,0) 75%)",
      }}
    >
      <Reveal className="max-w-3xl mx-auto text-center">
        <div className="flex items-center justify-center gap-4 mb-6">
          <span className="h-px w-8" style={{ background: PETROL, opacity: 0.45 }} aria-hidden="true" />
          <p className="font-body text-[11px] md:text-[12px] tracking-[0.38em] uppercase text-gold">
            Aktuális programok
          </p>
          <span className="h-px w-8" style={{ background: PETROL, opacity: 0.45 }} aria-hidden="true" />
        </div>
        <h1
          data-testid="group-programs-title"
          className="font-serif-display text-[36px] sm:text-[46px] md:text-[56px] leading-[1.1] text-graphite tracking-tight"
        >
          Tematikus Forrás-Kód<sup className="text-gold text-[0.45em] align-super">®</sup>
          <br />
          <em className="text-gold" style={{ fontStyle: "italic" }}>kiscsoportos alkalmak</em>
        </h1>
        <p
          data-testid="group-programs-subtitle"
          className="mt-6 md:mt-7 font-serif-display italic text-graphite-soft text-[20px] sm:text-[22px] md:text-[25px] leading-[1.5]"
        >
          A felismeréstől az új működésekig. Lépésről lépésre, egyre mélyebbre.
        </p>
        <p
          data-testid="group-programs-lead"
          className="mt-2 font-serif-display italic text-graphite-soft text-[20px] sm:text-[22px] md:text-[25px] leading-[1.5]"
        >
          Nem egyszerűen témákat dolgozunk fel.
          <br />
          Egy új működés lehetőségét építjük fel, rétegről rétegre.
        </p>
      </Reveal>

      <Prose className="mt-10 md:mt-14 space-y-6">
        {BODY.map((t) => (
          <p key={t.slice(0, 24)}>{t}</p>
        ))}
      </Prose>

      <Reveal className="mt-8 md:mt-10 text-center">
        <p data-testid="group-programs-closing" className={QUOTE}>
          Nem csupán új nézőpontokat keresünk. Teret nyitunk annak, hogy valóban új működések születhessenek.
        </p>
      </Reveal>
    </section>
  );
}
